(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('dropdownCloseOnClick', [DropdownCloseOnClickFn]);

    /* Metronic dropdown close on click directive */
    function DropdownCloseOnClickFn() {
        var directive = {
            link: link,
            scope: {
                id: '@'
            }
        };
        return directive;

        function link(scope, element) {
            // all li elements
            var li = element.find(".dropdown-menu li");
            //var li = document.querySelector('dp_' + scope.id); 

            // close on click
            li.on('click', function () {
                element.removeClass('open');
            });

            // destroy
            scope.$on("$destroy", function () {
                li.off('click');
            });
        }
    }

})();